import { connect, useDispatch } from 'react-redux';
import { resetOrder } from 'actions/orderSearch';
import { useEffect } from 'react';
import { fetchCurrentStaff } from 'actions/staffs';

let _content = null;

const OrderSearch = (props) => {
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(fetchCurrentStaff())
  }, [])

  return (
    _content &&
    _content({
      props,
      resetOrder,
    })
  );
};

const mapStateToProps = (state) => ({
  pending: state.orderSearch.pending,
  error: state.orderSearch.error,
  order: state.orderSearch.order,
});

const mapDispatchToProps = {
  resetOrder,
};

export default function (content) {
  _content = content;
  return connect(mapStateToProps, mapDispatchToProps)(OrderSearch);
}



// WEBPACK FOOTER //
// ./src/_pageContainers/orders/search/index.js